import { useEffect, useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap"

export const FeatureTabSizeModal = ({
  isOpen,
  onClose,
  sizes,
  setSizes,
  setFeatureMatrix,
  featureMatrix
}: {
  isOpen: boolean,
  onClose: () => void,
  sizes: string[],
  setSizes: (sizes: string[]) => void,
  setFeatureMatrix: (featureMatrix: Record<string, Record<string, boolean>>) => void,
  featureMatrix: Record<string, Record<string, boolean>>
}) => {

  console.log('featureMatrix', featureMatrix)
  const [selectedSize, setSelectedSize] = useState<string>('');
  type SizeRow = { id: string; value: string };
  const [rows, setRows] = useState<SizeRow[]>(
    sizes.map((s) => ({ id: s, value: s }))
  );

  useEffect(() => {
    if (!isOpen) return;
    setRows(sizes.map(s => ({ id: s, value: s })));
    setSelectedSize('');
  }, [isOpen, sizes]);

  const handleSizeUp = () => {
    const index = rows.findIndex(r => r.value === selectedSize);
    if (index === 0) {
      return;
    }

    setRows(prev => {
      const next = [...prev];
      const temp = next[index - 1];
      next[index - 1] = next[index];
      next[index] = temp;
      return next;
    });
  }

  const handleSizeDown = () => {
    const index = rows.findIndex(r => r.value === selectedSize);

    if (index === rows.length - 1) {
      return;
    }

    setRows(prev => {
      const next = [...prev];
      const temp = next[index + 1];
      next[index + 1] = next[index];
      next[index] = temp;
      return next;
    });
  }

  console.log('rows', rows);
  return (
    <Modal isOpen={isOpen} toggle={onClose} centered size="sm">
      <ModalHeader toggle={onClose}>Re-Order and Rename Size</ModalHeader>
      <ModalBody className="border rounded m-3">
        <h4>Size</h4>
        <ul className="list-unstyled d-flex flex-column gap-2 mb-3">
          {rows.map((row, index) => (
            <input
              key={row.id}
              type="text"
              value={row.value}
              placeholder="Size"
              onFocus={() => setSelectedSize(row.value)}
              onChange={(e) => {
                const value = e.target.value;
                setRows(prev => {
                  const next = [...prev];
                  next[index] = { ...next[index], value };
                  return next;
                });
                setSelectedSize(value);
              }}
              className={`form-control form-control-sm text-start ${selectedSize === row.value ? 'border-primary shadow-sm' : ''}`}
            />
          ))}
        </ul>
        <div className="d-flex gap-2 justify-content-end">
          <button className="btn btn-soft-primary btn-sm" onClick={handleSizeUp}>
            <i className="icon-up"></i>
            Up
          </button>
          <button className="btn btn-soft-primary btn-sm" onClick={handleSizeDown}>
            <i className="icon-down"></i>
            Down
          </button>
        </div>
      </ModalBody>
      <ModalFooter>
        <button
          onClick={() => {
            const newSizes = rows.map(r => r.value.trim()).filter(v => v !== '');

            const updatedMatrix: Record<string, Record<string, boolean>> = {};
            rows.forEach(r => {
              const oldName = r.id; // stable identifier
              const newName = r.value.trim();
              if (!newName) return;
              const oldRow = featureMatrix[oldName] || {};
              updatedMatrix[newName] = { ...oldRow };
            });

            setSizes(newSizes);
            setFeatureMatrix(updatedMatrix);
            setSelectedSize('')
            onClose();
          }}
          className='btn btn-soft-success btn-sm'
          style={{ minWidth: 80 }}
        >
          Save
        </button>
        <button
          onClick={onClose}
          className='btn btn-soft-danger btn-sm'
          style={{ minWidth: 80 }}
        >
          Cancel
        </button>
      </ModalFooter>

    </Modal>
  )
}